import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import ProjectGallery from './ProjectGallery';
import WhyChooseUs from './WhyChooseUs';
import Testimonials from './Testimonials';
import Contact from './Contact';
import Footer from './Footer';
import StickyBottomBar from './StickyBottomBar';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <ProjectGallery />
        <WhyChooseUs />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <StickyBottomBar />
    </div>
  );
};

export default LandingPage;
